import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "exportButton", "form", "toggleAllCheckbox"];

  connect() {
    this._boundFormChange = this.handleFormChange.bind(this);
    this._boundFormKeydown = this.handleFormKeydown.bind(this);
    this.formTarget.addEventListener("change", this._boundFormChange);
    this.formTarget.addEventListener("keydown", this._boundFormKeydown);
    this.resetFormToFilterMode();

    this.updateExportButton();
  }

  disconnect() {
    this.formTarget.removeEventListener("change", this._boundFormChange);
    this.formTarget.removeEventListener("keydown", this._boundFormKeydown);
  }

  handleFormChange(event) {
    const target = event.target;
    if (this.checkboxTargets.some((cb) => cb === target)) {
      this.updateToggleAllState();
      this.updateExportButton();
    }
  }

  handleFormKeydown(event) {
    const target = event.target;
    if (target.type !== "checkbox") return;
    if (event.key !== " " && event.key !== "Enter") return;

    if (target.id === "select_all_versions" || target.id === "select_all_threads") {
      event.preventDefault();
      target.checked = !target.checked;
      this.toggleAll(event);
      return;
    }

    if (this.checkboxTargets.some((cb) => cb === target)) {
      event.preventDefault();
      target.checked = !target.checked;
      target.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked;
    });
    this.updateExportButton();
  }

  updateToggleAllState() {
    if (!this.hasToggleAllCheckboxTarget) {
      return;
    }

    const total = this.checkboxTargets.length;
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;

    if (total === 0) {
      this.toggleAllCheckboxTarget.checked = false;
      this.toggleAllCheckboxTarget.indeterminate = false;
      return;
    }

    if (checkedCount === 0) {
      this.toggleAllCheckboxTarget.checked = false;
      this.toggleAllCheckboxTarget.indeterminate = false;
    } else if (checkedCount === total) {
      this.toggleAllCheckboxTarget.checked = true;
      this.toggleAllCheckboxTarget.indeterminate = false;
    } else {
      this.toggleAllCheckboxTarget.checked = false;
      this.toggleAllCheckboxTarget.indeterminate = true;
    }
  }

  submitExportForm(event) {
    event.preventDefault();

    const exportUrl = this.element.dataset.aiAssistantThreadExportUrl;
    if (!exportUrl) return;

    this.formTarget.setAttribute("action", exportUrl);
    this.formTarget.setAttribute("method", "post");
    this.formTarget.setAttribute("data-turbo", "false");
    this.formTarget.submit();
    window.setTimeout(() => this.resetFormToFilterMode(), 0);
  }

  resetFormToFilterMode() {
    const filterUrl = this.element.dataset.aiVersionsFilterUrl;
    if (filterUrl) {
      this.formTarget.setAttribute("action", filterUrl);
    }
    const resetMethod = (this.element.dataset.aiVersionsResetMethod || "get").toLowerCase();
    this.formTarget.setAttribute("method", resetMethod);
  }

  updateExportButton() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked);
    this.exportButtonTarget.textContent = anyChecked ? "Export selected" : "Export";
    this.exportButtonTarget.classList.remove("disabled");
    this.exportButtonTarget.setAttribute("aria-disabled", "false");
    this.exportButtonTarget.removeAttribute("tabindex");
  }
}
